import { ArrowDown, ArrowUp } from "lucide-react";
import { twMerge } from "tailwind-merge";

import { Badge } from "@/components/badge";

import { formatMetric } from "../formatMetric";

export function MetricCard({
  className,
  current,
  description,
  label,
  previous,
}: {
  className?: string;
  current: number;
  description: string;
  label: string;
  previous: number;
}) {
  const change = previous === 0 ? null : (current - previous) / previous;

  return (
    <div className={twMerge("flex flex-col gap-sm p-xl", className)}>
      <span className="text-sm font-semibold text-text-secondary">{label}</span>
      <div className="flex items-center gap-md">
        <span className="text-display-sm font-semibold text-text-primary">
          {formatMetric(current)}
        </span>
        {change !== null && (
          <Badge
            isRounded
            size="small"
            variant={change >= 0 ? "success" : "error"}
          >
            <span className="flex items-center gap-xxs">
              {change >= 0 ? (
                <ArrowUp className="size-3" />
              ) : (
                <ArrowDown className="size-3" />
              )}
              {Math.abs(Math.round(change * 100))}%
            </span>
          </Badge>
        )}
      </div>
      <span className="text-sm text-text-tertiary">{description}</span>
    </div>
  );
}
